import React, { useState } from 'react'
import {
  Button,
  Input,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Label,
  Alert,
} from 'reactstrap'
import { AiFillCloseCircle } from 'react-icons/ai'
import axios from '../../../axios'
import * as url from '../../../utils/url'
import { snapToQuarterHour } from '../../../utils/dateUtils'
import { connect } from 'react-redux'
import * as actionCreators from '../../../../src/modules/actions/index'
import { BiX } from 'react-icons/bi'
import { LuCheck, LuSlidersHorizontal } from 'react-icons/lu'
import Select from 'react-select'
import {
  isTrivvyGeneratedFromCustomTemplates,
  minPlanLimitCheck,
  scheduleMinTime,
  NUMBER_OF_ATTEMPTS_ALLOWED,
  TRIVVY_ADMIN_EMAIL_TYPES,
  TRIVVY_REMINDER_NOTIFICATION_FREQUENCY,
  WEEK_DAYS,
} from '../data'
import { toastContainer } from '../../../utils/toast'
import Toggle from 'react-toggle'
import OoPopover from '../../../components/UI/Popover/OoPopover'
import ReactDatePicker from 'react-datepicker'
import moment from 'moment'
import UpgradeTag from '../../../components/UpgradeTag'
import {
  TRIVVY_SETTINGS_MODAL_CANCEL_LABEL,
  TRIVVY_SETTINGS_MODAL_SUBTITLE,
} from '../../../utils/constants'
import '../trivvy-settings-bwai.css'

function AdvanceTrivvySettingModal({
  open,
  onClose,
  trivia,
  setCurrentTrivia,
  saveData,
  user,
  onlyShowMessagingSettings,
}) {
  const hideRemindInvitedSection = true;
  const [adminEmailTriggerType, setAdminEmailTriggerType] = useState(
    trivia.adminEmailTriggerType
  )
  // const [adminEmailTriggerType, setAdminEmailTriggerType] = useState(2)

  const [randomizeQuestions, setRandomizeQuestions] = useState(
    trivia.randomizeQuestions
  )

  const [
    notifyAdminWhenUserRepliesToMessages,
    setNotifyAdminWhenUserRepliesToMessages,
  ] = useState(trivia.notifyAdminWhenUserRepliesToMessages)

  const [
    sendResultSummaryAsTextAfterTrivvyEnds,
    setSendResultSummaryAsTextAfterTrivvyEnds,
  ] = useState(trivia.sendResultSummaryAsTextAfterTrivvyEnds)

  const isNonMcqTrivvy =
    trivia &&
    trivia.questions &&
    trivia.questions.filter((x) => x.question_type === 'MCQ').length == 0

  // Determine trivia type
  const isSurvey = trivia.triviaCategoryType === "SURVEY" && !trivia.isMessaging

  const [allowAttempts, setAllowAttempts] = useState(trivia.allowAttempts)
  const [showPassingPercentInput, setShowPassingPercentInput] = useState(
    trivia.minimumPassingPercent && trivia.minimumPassingPercent > 0
      ? true
      : false
  )
  const [numberOfAttempts, setNumberOfAttempts] = useState(
    trivia.numberOfAttempts
  )

  const [trivvyEndDate, setTrivvyEndDate] = useState(trivia.trivvyEndDate)

  const [allowAnonymousResponses, setAllowAnonymousResponses] = useState(
    trivia.allowAnonymousResponses
  )

  const [anonymousDefaultOn, setAnonymousDefaultOn] = useState(
    trivia.anonymousDefaultOn || false
  )

  const [minimumDisplayThreshold, setMinimumDisplayThreshold] = useState(
    trivia.minimumDisplayThreshold !== false
  )

  const [minimumPassingPercent, setMiniumPassingPercent] = useState(
    trivia.minimumPassingPercent
  )

  const [scheduledDate, setScheduledDate] = useState(trivia.scheduledDate)

  const isEditable = trivia ? !trivia.isPublished : false

  const [
    reminderNotificationFrequency,
    setReminderNotificationFrequency,
  ] = useState(trivia.reminderNotificationFrequency)
  const [weeklyFrequencyDayOfWeek, setWeeklyFrequencyDayOfWeek] = useState(
    trivia.weeklyFrequencyDayOfWeek
  )

  const [timedQuestionsEnable, setTimedQuestionsEnable] = useState(
    trivia.timedQuestionsEnable
  )

  const updateAdvanceSettings = () => {
    const isReminderUpdated =
      reminderNotificationFrequency != trivia.reminderNotificationFrequency ||
      weeklyFrequencyDayOfWeek != trivia.weeklyFrequencyDayOfWeek
    const payload = {
      minimumPassingPercent: minimumPassingPercent,
      timedQuestionsEnable: timedQuestionsEnable,
      adminEmailTriggerType,
      reminderNotificationFrequency,
      weeklyFrequencyDayOfWeek:
        reminderNotificationFrequency == 4 ? weeklyFrequencyDayOfWeek : null,
      isReminderUpdated,
      triviaId: trivia._id,
      numberOfAttempts: allowAttempts == 1 ? numberOfAttempts : null,
      allowAttempts: allowAttempts,
      allowAnonymousResponses: allowAnonymousResponses,
      anonymousDefaultOn: allowAnonymousResponses ? anonymousDefaultOn : false,
      minimumDisplayThreshold: allowAnonymousResponses
        ? minimumDisplayThreshold
        : true,
      scheduledDate: scheduledDate,
      randomizeQuestions: randomizeQuestions,
      trivvyEndDate,
      sendResultSummaryAsTextAfterTrivvyEnds: sendResultSummaryAsTextAfterTrivvyEnds,
      notifyAdminWhenUserRepliesToMessages: notifyAdminWhenUserRepliesToMessages,
    }
    axios
      .post(url.updateAdvancedTrivvySettings, payload)
      .then(({ data }) => {
        setCurrentTrivia({
          ...trivia,
          reminderNotificationFrequency,
          weeklyFrequencyDayOfWeek,
          adminEmailTriggerType: adminEmailTriggerType,
          allowAttempts: payload.allowAttempts,
          numberOfAttempts: payload.numberOfAttempts,
          allowAnonymousResponses: payload.allowAnonymousResponses,
          anonymousDefaultOn: payload.anonymousDefaultOn,
          minimumDisplayThreshold: payload.minimumDisplayThreshold,
          timedQuestionsEnable: payload.timedQuestionsEnable,
          minimumPassingPercent: payload.minimumPassingPercent,
          scheduledDate: payload.scheduledDate,
          randomizeQuestions: randomizeQuestions,
          trivvyEndDate: payload.trivvyEndDate,
          sendResultSummaryAsTextAfterTrivvyEnds: sendResultSummaryAsTextAfterTrivvyEnds,
          notifyAdminWhenUserRepliesToMessages: notifyAdminWhenUserRepliesToMessages,
        })

        onClose()
      })
      .catch((err) => {
        toastContainer('Error while updating advanced settings')
      })
  }

  const getValueForAttemptDD = () => {
    if (allowAttempts == 0) {
      return 'NO'
    } else if (allowAttempts == 2) {
      return 'MANY'
    } else if (allowAttempts == 1) {
      return numberOfAttempts
    }
  }

  const currentPaymentPlan =
    user.profile &&
    user.profile.organizationId &&
    user.profile.organizationId.trivvyPlanType

  const planInvalid =
    user.profile && user.profile.organizationId
      ? ['001', '002'].includes(user.profile.organizationId.trivvyPlanType)
      : false

  const isEnterprisePlan = minPlanLimitCheck(currentPaymentPlan, '004')

  const handleMinPassChange = (e) => {
    const newValue = e.target.value
    if (!isNaN(newValue) && (newValue === '' || parseInt(newValue) <= 100)) {
      setMiniumPassingPercent(newValue)
      setAllowAttempts(2)
    }
  }

  return (
    <Modal isOpen={open} className="bwai-settings-modal">
      <ModalHeader className="trivia_modal_header_bg" toggle={onClose}>
        <span className="bwai-settings-title-row">
          <span className="bwai-settings-icon-tile">
            <LuSlidersHorizontal />
          </span>
          <span className="bwai-settings-title-text">
            <span className="bwai-settings-title">
              Advanced Settings
            </span>
            {!onlyShowMessagingSettings && (
              <span className="bwai-settings-subtitle">
                {TRIVVY_SETTINGS_MODAL_SUBTITLE}
              </span>
            )}
          </span>
        </span>
      </ModalHeader>
      <ModalBody className="p-3 advanced-settings-modal">
        {onlyShowMessagingSettings ? (
          <div className="my-4 d-flex align-items-center">
            {' '}
            <Label className="mb-0 bwai-settings-heading">
              {/* Notify me via email when users respond to text messages. */}
              Notify me via email when users respond.
            </Label>{' '}
            <Toggle
              checked={notifyAdminWhenUserRepliesToMessages}
              icons={false}
              onChange={(e) => {
                setNotifyAdminWhenUserRepliesToMessages(e.target.checked)
              }}
              className="ml-2"
            />
          </div>
        ) : (
          <div>
            {planInvalid ? (
              <Alert color="info">
                Please upgrade your package to gain access to the following
                features.
              </Alert>
            ) : (
              ''
            )}
            <div
              className="mb-4"
              style={{
                opacity: planInvalid ? 0.6 : 1,
              }}>
              <div className="mt-2">
                <Label>Recieve email after users take Trivvy</Label>
                <Select
                  options={TRIVVY_ADMIN_EMAIL_TYPES}
                  value={adminEmailTriggerType}
                  onChange={(v) => {
                    setAdminEmailTriggerType(v.value)
                  }}
                  placeholder="Set when you recieve email after users take Trivvy"
                  disabled={planInvalid}
                />
              </div>
              {!hideRemindInvitedSection && (
                <div className="mt-2">
                  <Label>Remind invited users via link </Label>
                  <Select
                    options={TRIVVY_REMINDER_NOTIFICATION_FREQUENCY}
                    value={reminderNotificationFrequency}
                    onChange={(v) => {
                      setReminderNotificationFrequency(v.value);
                    }}
                    placeholder="Remind invited users via email who hasnt taken it yet"
                    disabled={planInvalid}
                  />
                </div>
              )}  
              {reminderNotificationFrequency == 4 && (
                <div className="mt-2">
                  <Label>Choose day of week </Label>
                  <Select
                    options={WEEK_DAYS}
                    value={weeklyFrequencyDayOfWeek}
                    onChange={(v) => {
                      setWeeklyFrequencyDayOfWeek(v.value)
                    }}
                    placeholder="Select day of week to reminder"
                    disabled={planInvalid}
                  />
                </div>
              )}

              {isTrivvyGeneratedFromCustomTemplates(trivia) ||
              isNonMcqTrivvy ? (
                ''
              ) : !isSurvey ? (
                <div className="d-flex my-3 align-items-center">
                  <div>
                    <span className="bwai-settings-heading">
                      {showPassingPercentInput
                        ? 'Minimum passing percent on'
                        : 'Minimum passing percent off'}
                    </span>
                  </div>
                  <Toggle
                    checked={showPassingPercentInput}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setShowPassingPercentInput(true)
                      } else {
                        setMiniumPassingPercent(null)
                        setAllowAttempts(0)
                        setShowPassingPercentInput(false)
                      }
                    }}
                    className="ml-2"
                    disabled={
                      planInvalid ||
                      trivia.totalSubmissions > 0 ||
                      isNonMcqTrivvy ||
                      !isEditable
                    }
                  />

                  {showPassingPercentInput && (
                    <div className="ml-2">
                      <Input
                        type="number"
                        name="number"
                        style={{ width: '100px' }}
                        max={100}
                        value={minimumPassingPercent}
                        onChange={(e) => handleMinPassChange(e)}
                        disabled={
                          planInvalid ||
                          trivia.totalSubmissions > 0 ||
                          isNonMcqTrivvy ||
                          !isEditable
                        }
                      />
                    </div>
                  )}
                </div>
              ) : <></>}

              {minimumPassingPercent > 0 && (
                <Alert color="info" className="my-3">
                  Minimum percentage allows the number of retakes needed for
                  user to achieve percentage set.
                </Alert>
              )}

              {minimumPassingPercent && minimumPassingPercent > 0 && !isSurvey ? (
                <div className="my-2">
                  <Label>Allow retakes</Label>
                  <Input readOnly placeholder={'As many as needed'} />
                </div>
              ) : !isSurvey ? (
                <div className="my-2">
                  <div>
                    <Label>Allow retakes</Label>
                    <OoPopover
                      target="allow_retakes_tooltip"
                      headerText="Allow Retakes"
                      bodyText="This feature does not apply for sharing via SMS Text."
                      css_class="oo_popover_insights_tip"
                    />
                  </div>
              
                  <Select
                    id="allow_retakes_tooltip"
                    options={NUMBER_OF_ATTEMPTS_ALLOWED}
                    onChange={(e) => {
                      if (typeof e.value == 'number') {
                        setAllowAttempts(1)
                        setNumberOfAttempts(e.value)
                      } else {
                        if (e.value == 'NO') {
                          setAllowAttempts(0)
                          setNumberOfAttempts(null)
                        } else if (e.value == 'MANY') {
                          setAllowAttempts(2)
                          setNumberOfAttempts(null)
                        }
                      }

                      setNumberOfAttempts(e.value)
                    }}
                    value={getValueForAttemptDD()}
                    placeholder="Select No Of Attempts"
                    disabled={
                      planInvalid || trivia.totalSubmissions > 0 || !isEditable
                    }
                  />
                </div>
              ) : <></>}

              <div className="bwai-settings-card mt-4">
              <div className="bwai-settings-date-grid">
              <div className="my-2">
                <Label>
                  <span>Schedule Date</span>
                  {!isEnterprisePlan && <UpgradeTag text="Upgrade" />}
                </Label>
                <ReactDatePicker
                  dateFormat="MM/DD/YYYY 𝖺𝗍 h:mm a"
                  id="actionDueDate"
                  autoComplete="off"
                  placeholderText="Enter date: MM/DD/YYYY"
                  className="form-control filter-action-date-input"
                  minDate={new Date()}
                  minTime={scheduleMinTime(scheduledDate)}
                  maxTime={moment().endOf('day')}
                  selected={
                    typeof scheduledDate == 'string'
                      ? moment(scheduledDate)
                      : scheduledDate
                  }
                  onChange={(v) => {
                    if (v) {
                      const date = moment(v)
                      if (
                        moment()
                          .startOf('day')
                          .isSame(date, 'hour')
                      ) {
                    // Today @ midnight selected: bump to the next full hour (TBV-624: 00 min, 00 sec)
                        setScheduledDate(
                          moment()
                            .add(1, 'hour')
                            .startOf('hour')
                        )
                      } else {
                        if (
                          moment(date)
                            .startOf('day')
                            .isSame(date, 'hour')
                        ) {
                          // Future day @ midnight selected: default to 09:00:00
                          setScheduledDate(
                            date.add(9, 'hours').startOf('hour')
                          )
                        } else {
                           // Snap to the nearest quarter-hour (TBV: quarter-hour scheduling)
                          setScheduledDate(snapToQuarterHour(date))
                        }
                      }
                    } else {
                      setScheduledDate(null)
                    }
                  }}
                  showYearDropdown
                  showTimeSelect
                  timeFormat="h:mm a"
                  timeIntervals={15}
                  disabled={!isEnterprisePlan || !isEditable}
                />
              </div>

              <div className="my-2">
                <Label>End Date</Label>
                <ReactDatePicker
                  dateFormat="MM/DD/YYYY"
                  id="actionDueDate"
                  autoComplete="off"
                  placeholderText="Enter date: MM/DD/YYYY"
                  className="form-control filter-action-date-input"
                  selected={
                    typeof trivvyEndDate == 'string'
                      ? moment(trivvyEndDate).local()
                      : trivvyEndDate
                  }
                  onChange={(v) => {
                    if (v) {
                      const date = moment(v).startOf('day')
                      setTrivvyEndDate(date)
                    } else {
                      setTrivvyEndDate(null)
                    }
                  }}
                  showYearDropdown
                />
              </div>
              </div>
              </div>
            </div>

            {planInvalid && <hr />}

            <div className="bwai-settings-card bwai-settings-anon-card my-4">
              <div className="bwai-settings-anon-row">
                <Label className="mr-2 mb-0 bwai-settings-heading">Allow Anonymous Submissions</Label>
                <Toggle
                  checked={allowAnonymousResponses}
                  onChange={(e) => {
                    setAllowAnonymousResponses(e.target.checked)
                    if (!e.target.checked) {
                      setAnonymousDefaultOn(false)
                    }
                  }}
                  icons={false}
                  disabled={!isEditable}
                />
              </div>

              <div
                className={
                  allowAnonymousResponses
                    ? 'bwai-settings-anon-subpanel'
                    : 'bwai-settings-anon-subpanel is-disabled'
                }>
                <div className="bwai-settings-anon-subrow">
                  <Label className="mb-0 bwai-settings-heading">
                    Default Anonymity to ON for Users
                  </Label>
                  <Toggle
                    checked={anonymousDefaultOn}
                    onChange={(e) => {
                      setAnonymousDefaultOn(e.target.checked)
                    }}
                    icons={false}
                    disabled={!isEditable || !allowAnonymousResponses}
                  />
                </div>
                <div className="bwai-settings-anon-subrow">
                  <div className="d-flex align-items-center">
                    <Label className="mb-0 bwai-settings-heading">Minimum Display Threshold</Label>
                    <OoPopover
                      target="minimum_display_threshold_tooltip"
                      headerText="Minimum Display Threshold"
                      bodyText="When enabled, results and insights are hidden until more than 5 people have responded, helping protect participant anonymity."
                    />
                  </div>
                  <Toggle
                    checked={minimumDisplayThreshold}
                    onChange={(e) => {
                      setMinimumDisplayThreshold(e.target.checked)
                    }}
                    icons={false}
                    disabled={!isEditable || !allowAnonymousResponses}
                  />
                </div>
              </div>
            </div>

            {
            !isSurvey ? <div className="my-4 d-flex align-items-center">
              {' '}
              <Label className="mb-0 bwai-settings-heading">
                {timedQuestionsEnable
                  ? 'Timed questions on. Click to turn off timed questions.'
                  : 'Timed questions off. Click to turn on.'}
              </Label>{' '}
              <Toggle
                checked={timedQuestionsEnable}
                icons={false}
                onChange={(e) => {
                  setTimedQuestionsEnable(e.target.checked)
                }}
                className="ml-4"
                disabled={isNonMcqTrivvy || !isEditable}
              />
            </div> : <></>
            }

           {
            !isSurvey ?  <div className="my-4 d-flex align-items-center">
              {' '}
              <Label className="mb-0 bwai-settings-heading">
                {!randomizeQuestions
                  ? 'Randomize questions off.'
                  : 'Randomize questions on. Click to turn off.'}
              </Label>{' '}
              <Toggle
                checked={randomizeQuestions}
                icons={false}
                onChange={(e) => {
                  setRandomizeQuestions(e.target.checked)
                }}
                className="ml-2"
              />
            </div> :  <></>
        }
          </div>
        )}

        {/* <div className="my-4 d-flex align-items-center">
          {" "}
          <Label className="mb-0 bwai-settings-heading">
          Send text with results of trivvy once trivvy ends?
          </Label>{" "}
          <Toggle
            checked={sendResultSummaryAsTextAfterTrivvyEnds}
            icons={false}
            onChange={(e) => {
              setSendResultSummaryAsTextAfterTrivvyEnds(e.target.checked);
            }}
            className="ml-2"
          />
        </div> */}
      </ModalBody>
      <ModalFooter>
        <Button
          className="bwai-settings-cancel"
          onClick={() => {
            onClose()
          }}>
          {TRIVVY_SETTINGS_MODAL_CANCEL_LABEL}
        </Button>
        <Button
          className="trivia-action-button-main"
          onClick={() => {
            updateAdvanceSettings()
          }}>
          <LuCheck />
          Update Settings
        </Button>
      </ModalFooter>
    </Modal>
  )
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setCreateTrivvyLoader: (data) =>
      dispatch(actionCreators.setCreateTrivvyLoader(data)),
    setImportTemplateAddedTrivvys: (data) =>
      dispatch(actionCreators.setImportTemplateAddedTrivvys(data)),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AdvanceTrivvySettingModal)
